// client/src/components/AppNavbar.js

import React, { useState } from "react";
import {
  Navbar,
  Container,
  Nav,
  Form,
  FormControl,
  InputGroup,
  Button,
  NavDropdown,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaSearch, FaUserCircle } from "react-icons/fa";
import { useAuth } from '../context/AuthContext';
import golfCourses from "../data/courses_for_searchbar";

const AppNavbar = ({ date, setDate, searchQuery, setSearchQuery, searchType, setSearchType }) => {
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState({
    courses: [],
    cities: [],
    zipCodes: [],
  });
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleSearchChange = (e) => {
    const input = e.target.value;
    setSearchInput(input);

    if (input.length < 2) {
      setSearchResults({ courses: [], cities: [], zipCodes: [] });
      setShowDropdown(false);
      return;
    }
    const courseMatches = golfCourses.filter((course) => course.name && course.name.toLowerCase().includes(input.toLowerCase())).slice(0, 3);
    const cityMatches = [...new Set(golfCourses.filter((course) => course.city && course.city.toLowerCase().includes(input.toLowerCase())).map((course) => course.city))].slice(0, 3);
    const zipMatches = /^\d+$/.test(input) ? golfCourses.filter((course) => course.zip && course.zip.startsWith(input)).map((course) => course.zip).slice(0, 3) : [];

    setSearchResults({ courses: courseMatches, cities: cityMatches, zipCodes: zipMatches });
    setShowDropdown(true);
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
  };

  const handleSelect = (value, category) => {
    setSearchInput(value);
    setSearchQuery(value);
    setSearchType(category);
    setShowDropdown(false);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!searchQuery || !searchType) {
      alert("Please select a course, city, or zip from the dropdown.");
      return;
    }
    navigate(`/search?date=${date}&searchQuery=${searchQuery}&searchType=${searchType}`);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login'); // Redirect to login on logout
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
      <Container className="d-flex justify-content-between align-items-center">
        <Navbar.Brand as={Link} to="/search" className="me-auto">
          Outivity Golf
        </Navbar.Brand>

        {/* ✅ RESTORED: The full search bar form, only shown if a user is logged in */}
        {user && (
          <Form className="mx-auto w-75" onSubmit={handleSearchSubmit}>
            <Row className="align-items-center justify-content-md-center gx-2">
              <Col xs={6}>
                <InputGroup>
                  <FormControl
                    type="search"
                    placeholder="Search course, city, zip"
                    value={searchInput}
                    onChange={handleSearchChange}
                    onFocus={() => searchInput.length >= 2 && setShowDropdown(true)}
                    onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
                  />
                </InputGroup>
                <Dropdown show={showDropdown} className="w-100">
                  <Dropdown.Menu className="w-100 mt-1 shadow-lg" style={{ maxHeight: "250px", overflowY: "auto", zIndex: 1050 }}>
                    {searchResults.courses.length > 0 && (
                      <>
                        <Dropdown.Header>Courses</Dropdown.Header>
                        {searchResults.courses.map((course) => (
                          <Dropdown.Item key={course.name} onClick={() => handleSelect(course.name, "course")}>{course.name}</Dropdown.Item>
                        ))}
                      </>
                    )}
                    {searchResults.cities.length > 0 && (
                      <>
                        <Dropdown.Header>Cities</Dropdown.Header>
                        {searchResults.cities.map((city) => (
                          <Dropdown.Item key={city} onClick={() => handleSelect(city, "city")}>{city}</Dropdown.Item>
                        ))}
                      </>
                    )}
                    {searchResults.zipCodes.length > 0 && (
                      <>
                        <Dropdown.Header>Zip Codes</Dropdown.Header>
                        {searchResults.zipCodes.map((zip) => (
                          <Dropdown.Item key={zip} onClick={() => handleSelect(zip, "zip")}>{zip}</Dropdown.Item>
                        ))}
                      </>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col xs="auto">
                <FormControl type="date" value={date} onChange={handleDateChange} />
              </Col>
              <Col xs="auto">
                <Button variant="primary" type="submit"><FaSearch /></Button>
              </Col>
            </Row>
          </Form>
        )}

        <Nav className="ms-auto d-flex align-items-center">
          {user ? (
            <>
              {/* ✅ ADDED: Bug Report Link */}
              <Nav.Link
                href="https://forms.gle/sBi9kceKVnxBx2Gw8"
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
              >
                Submit Bug
              </Nav.Link>

              <NavDropdown title={<FaUserCircle size={24} />} id="profile-nav-dropdown" align="end">
                <NavDropdown.Item as={Link} to="/profile">Profile</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/bookings">My Bookings</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/favorite-courses">Favorites</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </>
          ) : (
            <Nav.Link as={Link} to="/login">Login</Nav.Link>
          )}
        </Nav>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;